<script setup lang="ts">
import GradeLevelTagLabel from "~components/GradeLevelTagLabel.vue"
import {LessonRow} from "~components/teacher/assign/assignment"

defineProps<{lesson: LessonRow}>()
defineEmits(["click"])
</script>

<template>
  <GradeLevelTagLabel :grade="lesson.grade_level" :title="lesson.title" v-bind="$attrs" @click="$emit('click')" />
</template>
